module.exports = __webpack_public_path__ + "static/getconf19-64c6216d89891c869b93583457529ea7.jpeg";